import * as React from 'react';
import { Provider } from 'mobx-react';
import { ContentOrganizerPortalStore } from './stores';
import { ContentOrganizerPortal } from './ContentOrganizerPortal';
import { LoggingService } from '../../services/LoggingService';

export interface IProps {
  environment: "Development" | "Test" | "Production";
  tenant: string;
  token: string;
  instances: string[];
  searchPlaceholder: string;
  title: string;
  backgroundColor?: string;
  textColor?: string;
  showDropShadow?: boolean;
  borderColor?: string;
  numberOfCardsPerRow?: number;
}

export class IAContentOrganizerPortal extends React.Component<IProps> {

  private contentOrganizerPortalStore: ContentOrganizerPortalStore;

  constructor(props: IProps) {
    super(props);
    LoggingService.init(this.props.environment);
    this.contentOrganizerPortalStore = new ContentOrganizerPortalStore();
    this.contentOrganizerPortalStore.environment = props.environment;
    this.contentOrganizerPortalStore.token = props.token;
    this.contentOrganizerPortalStore.tenant = props.tenant;
    this.contentOrganizerPortalStore.title = props.title;
    this.contentOrganizerPortalStore.numberOfCardsPerRow = props.numberOfCardsPerRow ? props.numberOfCardsPerRow : 5;
    this.contentOrganizerPortalStore.listInstances = undefined;
    this.contentOrganizerPortalStore.searchPlaceholder = props.searchPlaceholder;
    this.contentOrganizerPortalStore.design = {
      backgroundColor: props.backgroundColor ? props.backgroundColor : "#ffffff",
      textColor: props.textColor ? props.textColor : "#333333",
      showDropShadow: props.showDropShadow != undefined ? props.showDropShadow : true,
      borderColor: props.borderColor ? props.borderColor : undefined
    };

    let searchQuery = "";
    if (this.props.instances && this.props.instances.length > 0) {
      this.props.instances.forEach(instance => {
        if (searchQuery !== "") {
          searchQuery += " or ";
        }
        searchQuery += `IAInstanceInternalName eq '${instance}'`;
      });
    }
    this.contentOrganizerPortalStore.updateSearchQuery(searchQuery);
  }

  public componentWillReceiveProps(props: IProps) {
    this.contentOrganizerPortalStore.environment = props.environment;
    this.contentOrganizerPortalStore.token = props.token;
    this.contentOrganizerPortalStore.tenant = props.tenant;
    this.contentOrganizerPortalStore.title = props.title;
    this.contentOrganizerPortalStore.numberOfCardsPerRow = props.numberOfCardsPerRow ? props.numberOfCardsPerRow : 5;
    this.contentOrganizerPortalStore.searchPlaceholder = props.searchPlaceholder;
    this.contentOrganizerPortalStore.design = {
      backgroundColor: props.backgroundColor ? props.backgroundColor : "#ffffff",
      textColor: props.textColor ? props.textColor : "#333333",
      showDropShadow: props.showDropShadow != undefined ? props.showDropShadow : true,
      borderColor: props.borderColor ? props.borderColor : undefined
    };
    if (JSON.stringify(props.instances) !== JSON.stringify(this.props.instances) || props.searchPlaceholder !== this.props.searchPlaceholder) {
      this.contentOrganizerPortalStore.searchPlaceholder = props.searchPlaceholder;
      let searchQuery = "";
      if (props.instances && props.instances.length > 0) {
        props.instances.forEach(instance => {
          if (searchQuery !== "") {
            searchQuery += " or ";
          }
          searchQuery += `IAInstanceInternalName eq '${instance}'`;
        });
      }
      this.contentOrganizerPortalStore.listInstances = undefined;
      this.contentOrganizerPortalStore.updateSearchQuery(searchQuery);
    }
  }

  render() {
    return (
      <Provider contentOrganizerPortalStore={this.contentOrganizerPortalStore}>
        <ContentOrganizerPortal />
      </Provider>
    )
  }
}